import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiLoginRefreshTokenMutationRequest,
  PostApiLoginRefreshTokenMutationResponse,
} from "../../../types/PostApiLoginRefreshToken";

export function getPostApiLoginRefreshTokenUrl() {
  return `/api/Login/refresh-token` as const;
}

/**
 * {@link /api/Login/refresh-token}
 */
export async function postApiLoginRefreshToken(
  data?: PostApiLoginRefreshTokenMutationRequest,
  config: Partial<RequestConfig<PostApiLoginRefreshTokenMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiLoginRefreshTokenMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginRefreshTokenMutationRequest
  >({
    method: "POST",
    url: getPostApiLoginRefreshTokenUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
